import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorder} from "../TheBorder";
import {TheBorderGameAssets} from "../TheBorderGameAssets";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2022-08-24.
 */

export class TheBorderIntroPanView extends PIXI.Container implements StageLayer {

    private static MULE_INTRO_ANIMATION:string = "Mule";
    private static CAYOTE_INTRO_ANIMATION:string = "Cayote";

    private _spineAnimation:PIXI.spine.Spine;
    private _mulePanTL:gsap.core.Timeline;
    private _cayotePanTL:gsap.core.Timeline;

    constructor() {
        super();
        this.name = "TheBorderIntroPanView";
        this.init();
    }

    private init():void {
        this._spineAnimation = new PIXI.spine.Spine(TheBorder.assetLoader.getSpineAsset(TheBorderGameAssets.FS_AND_SUPER_FS_INTRO_SPINE));
        this._spineAnimation.visible = false;
        this._spineAnimation.position.set(360, 360);
        this.addChild(this._spineAnimation);

        this._mulePanTL = gsap.timeline({paused: true});
        this._mulePanTL.add(() => {
            this.prepareSpine();
        });
        this._mulePanTL.add(new SpineTween(this._spineAnimation, 0, TheBorderIntroPanView.MULE_INTRO_ANIMATION));
        this._mulePanTL.add(() => {this._spineAnimation.visible = false});

        this._cayotePanTL = gsap.timeline({paused: true});
        this._cayotePanTL.add(() => {
            this.prepareSpine();
        });
        this._cayotePanTL.add(new SpineTween(this._spineAnimation, 0, TheBorderIntroPanView.CAYOTE_INTRO_ANIMATION));
        this._cayotePanTL.add(() => {this._spineAnimation.visible = false});
    }

    public getMulePanAnimation():gsap.core.Timeline {
        return this._mulePanTL;
    }

    public getCayotePanAnimation():gsap.core.Timeline {
        return this._cayotePanTL;
    }

    private prepareSpine():void {
        this._spineAnimation.state.clearTracks();
        if(!this._spineAnimation.visible) {
            this._spineAnimation.visible = true;
            this._spineAnimation.updateTransform();
        }
        this._spineAnimation.skeleton.setSlotsToSetupPose();
        this._spineAnimation.skeleton.setToSetupPose();
        this._spineAnimation.state.setEmptyAnimation(0, 0);
    }
}